import { render, staticRenderFns } from "./StudentPortraitScreen.vue?vue&type=template&id=d78fcaec&scoped=true"
import script from "./StudentPortraitScreen.vue?vue&type=script&lang=js"
export * from "./StudentPortraitScreen.vue?vue&type=script&lang=js"
import style0 from "./StudentPortraitScreen.vue?vue&type=style&index=0&id=d78fcaec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78fcaec",
  null
  
)

export default component.exports